import React from "react";
import { DPButton } from "Components/DP";
import mutations from "Shared/mutations";
import { useMutation, PureQueryOptions } from "@apollo/client";
import { TerminateUserMutation, TerminateUserMutationVariables } from "generated/graphql";

type Props = {
  onSubmit: (deductionAmountCents: number) => void;
  onError: () => void;
  employeeProfileId: string;
  refetchQueries?: (string | PureQueryOptions)[];
};

const TerminateUserSubmitButton = ({
  onSubmit,
  employeeProfileId,
  onError,
  refetchQueries,
}: Props) => {
  const [terminateUserFn] = useMutation<TerminateUserMutation, TerminateUserMutationVariables>(
    mutations.TERMINATE_USER,
    {
      variables: { employeeProfileId },
    }
  );

  const handleOnSubmit = async () => {
    try {
      const result = await terminateUserFn({
        refetchQueries,
      });

      if (
        result &&
        result.data &&
        result.data.terminateUser &&
        result.data.terminateUser.deductionAmountCents >= 0
      ) {
        onSubmit(result.data.terminateUser.deductionAmountCents);
      }
    } catch {
      onError();
    }
  };

  return (
    <DPButton
      id="submit"
      align="right"
      color="primary"
      onClick={handleOnSubmit}
    >
      Report Termination
    </DPButton>
  );
};

export default TerminateUserSubmitButton;
